import { clsx } from "clsx";
import { memo } from "react";
import "./HighlightedText.scss";

interface IHighlightedText {
  text: string;
  highlight: string;
}

export const HighlightedText: React.FC<IHighlightedText> = memo(({
  text,
  highlight
}) => {
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));

  return <span className={clsx(!highlight.length && "HighlightedText")}> { parts.map((part, i) =>
    <span key={i} className={clsx(
      part.toLowerCase() === highlight.toLowerCase() && "HighlightedText-ActiveLetter"
    )}>
      {part}
    </span>)
  } </span>;
});
